export default "__VITE_ASSET__gDtDxpel__"